/*
  Nature Lane Beauty — reveal on scroll (custom build #7)

  Design spec: 16px rise, 620ms, disabled under reduced-motion.
  Reference implementation: Nature Lane Beauty.dc.html L1264.

  Progressive enhancement: the hiding styles live behind `.nlb-reveal-ready`,
  which this script only adds when JS runs and motion is allowed. If the script
  never executes, or the user prefers reduced motion, content stays visible.
*/
(function () {
  'use strict';

  var root = document.documentElement;

  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  root.classList.add('nlb-reveal-ready');

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.setAttribute('data-nlb-revealed', '');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '-40px' }
  );

  function observe(scope) {
    (scope || document).querySelectorAll('[data-nlb-reveal]:not([data-nlb-revealed])').forEach(function (node) {
      observer.observe(node);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      observe();
    });
  } else {
    observe();
  }

  // Re-scan when a section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    observe(event.target);
  });
})();
